document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ckb').forEach(initBundle);
});
function openCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('cart-drawer');
      var oldDrawer = document.querySelector('cart-drawer');
      if (newDrawer && oldDrawer) {
        oldDrawer.innerHTML = newDrawer.innerHTML;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.add('active', 'animate');
        document.body.classList.add('overflow-hidden');
      }
    })
    .catch(function (err) {
      console.error('Could not refresh cart drawer, falling back to /cart', err);
      window.location.href = '/cart';
    });
}
function initBundle(root) {
  const variantId = root.dataset.variantId;
  const sellingPlanId = root.dataset.sellingPlanId;
  const subDiscount = parseFloat(root.dataset.subscriptionDiscount || '0');

  const radios = root.querySelectorAll('.ckb__radio-input');
  const bars = root.querySelectorAll('.ckb__bar');
  const subToggle = root.querySelector('.ckb-js-subscription-toggle');
  const atcBtn = root.querySelector('.ckb-js-atc');
  const atcPrice = root.querySelector('.ckb-js-atc-price');
  const atcCompare = root.querySelector('.ckb-js-atc-compare');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedBar() {
    const checked = root.querySelector('.ckb__radio-input:checked');
    return checked ? checked.closest('.ckb__bar') : bars[0];
  }

function isSubscribed() {
  if (subToggle) return subToggle.checked;
  return root.dataset.subscribeByDefault === 'true';
}

  function updatePrices() {
    bars.forEach(function (bar) {
      const finalTotal = parseInt(bar.dataset.finalTotal, 10);
      const compareTotal = parseInt(bar.dataset.compareTotal, 10);
      let displayedTotal = finalTotal;

      if (isSubscribed() && subDiscount > 0) {
        displayedTotal = Math.round(finalTotal * (1 - subDiscount / 100));
      }

      const priceEl = bar.querySelector('.ckb-js-price');
      const compareEl = bar.querySelector('.ckb-js-compare');
      if (priceEl) priceEl.textContent = formatMoney(displayedTotal);
      if (compareEl) compareEl.textContent = formatMoney(compareTotal);
    });

    const selected = getSelectedBar();
    if (selected) {
      const finalTotal = parseInt(selected.dataset.finalTotal, 10);
      const compareTotal = parseInt(selected.dataset.compareTotal, 10);
      let displayedTotal = finalTotal;
      if (isSubscribed() && subDiscount > 0) {
        displayedTotal = Math.round(finalTotal * (1 - subDiscount / 100));
      }
      if (atcPrice) atcPrice.textContent = formatMoney(displayedTotal);
      if (atcCompare) atcCompare.textContent = formatMoney(compareTotal);
    }
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      bars.forEach(function (bar) { bar.classList.remove('ckb__bar--selected'); });
      radio.closest('.ckb__bar').classList.add('ckb__bar--selected');
      updatePrices();
    });
  });

  if (subToggle) {
    subToggle.addEventListener('change', updatePrices);
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      const selected = getSelectedBar();
      if (!selected) return;

      const quantity = parseInt(selected.dataset.quantity, 10) || 1;
      const gift1 = selected.dataset.gift1Variant;
      const gift2 = selected.dataset.gift2Variant;

      const items = [{
        id: variantId,
        quantity: quantity
      }];

      if (isSubscribed() && sellingPlanId) {
        items[0].selling_plan = sellingPlanId;
      }

      if (gift1) {
        items.push({ id: gift1, quantity: 1, properties: { '_free_gift': 'true' } });
      }
      if (gift2) {
        items.push({ id: gift2, quantity: 1, properties: { '_free_gift': 'true' } });
      }

      atcBtn.disabled = true;
      const originalText = atcBtn.querySelector('.ckb__atc-text').textContent;
      atcBtn.querySelector('.ckb__atc-text').textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
  document.dispatchEvent(new CustomEvent('cart:updated'));
  openCartDrawer();
})
        .catch(function (err) {
          console.error(err);
          alert('Something went wrong adding this to your cart.');
        })
        .finally(function () {
          atcBtn.disabled = false;
          atcBtn.querySelector('.ckb__atc-text').textContent = originalText;
        });
    });
  }

  updatePrices();
}